import React, { createContext, useState } from 'react'
import GeolocalizationContextProvider from './geolocalization-context'

const defaultState = {
  currentPageContext: '',
  modalOpen: '',
  modalContent: '',
  isMobile: false
}
export const PageContext = createContext(defaultState)

const PageContextProvider = props => {
  const [currentPageContext, setCurrentPageContext] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  return (
    <PageContext.Provider value={{
      currentPage: [currentPageContext, setCurrentPageContext],
      modalState: [modalOpen, setModalOpen],
      modalCont: [modalContent, setModalContent],
      mobileState: [isMobile, setIsMobile],
    }}>
      <GeolocalizationContextProvider
        pageGating={props.pageGating ? props.pageGating : false}
      >
        {props.children}
      </GeolocalizationContextProvider>
    </PageContext.Provider>
  )
}

export default PageContextProvider
